import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { Languages } from "lucide-react";

export const LANGS = [
  ["ru", "Русский"], ["en", "English"], ["fr", "Français"], ["tr", "Türkçe"], ["de", "Deutsch"], ["es", "Español"],
  ["it", "Italiano"], ["pt", "Português"], ["nl", "Nederlands"], ["pl", "Polski"], ["uk", "Українська"], ["ar", "العربية"],
  ["he", "עברית"], ["zh", "中文"], ["ja", "日本語"], ["ko", "한국어"],
];
const label = (code) => (LANGS.find(([c]) => c === code) || [code, code])[1];

export default function ClientLanguage({ client, t, onChanged }) {
  const [val, setVal] = useState(client.language || "");
  const [busy, setBusy] = useState(false);

  const save = async (v) => {
    setVal(v); setBusy(true);
    try {
      await axios.put(`${API}/clients/${client.phone_key}/language`, { language: v || null });
      toast.success(t("clients.langSaved"));
      onChanged?.(v || null);
    } catch { toast.error("Error"); }
    setBusy(false);
  };

  const autoText = client.language_auto ? `${t("clients.langAuto")} — ${label(client.language_auto)}` : t("clients.langAutoUnknown");
  return (
    <div className="col-span-2" data-testid={`client-lang-${client.phone_key}`}>
      <p className="text-gray-500 text-xs flex items-center gap-1"><Languages size={12} /> {t("clients.language")}</p>
      <select value={val} disabled={busy} onChange={(e) => save(e.target.value)} data-testid={`client-lang-select-${client.phone_key}`}
        className="mt-1 w-full sm:w-auto h-9 border-2 border-black rounded-md px-2 text-sm bg-white font-medium">
        <option value="">{autoText}</option>
        {LANGS.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
      </select>
      <p className="text-[11px] text-gray-500 mt-1">{t("clients.langHint")}</p>
    </div>
  );
}
